/**
 * EmojiProviderSetup — kaynak-referans `features/messaging/utils/markdown/EmojiProviderSetup.ts` portu.
 *
 * Markdown ayrıştırıcının Unicode-emoji sağlayıcısını (Unicode emoji arama/skin-tone
 * çözümleme) merkezi `EmojiParsers` konfigürasyonuna bağlar.
 */

import UnicodeEmojis from "@app/features/expressions/utils/UnicodeEmojis";
import { type EmojiProvider, setEmojiParserConfig } from "@app/features/messaging/utils/markdown/parser/EmojiParsers";
import { SKIN_TONE_SURROGATES } from "@app/features/emoji/utils/EmojiConstants";

const emojiProvider: EmojiProvider = {
  getSurrogateName: UnicodeEmojis.getSurrogateName,
  findEmojiByName: UnicodeEmojis.findEmojiByShortcodeName,
  findEmojiWithSkinTone: UnicodeEmojis.findEmojiWithSkinTone,
};

/** Markdown ayrıştırıcının global emoji konfigürasyonunu Unicode sağlayıcısıyla başlatır. */
export function initializeEmojiParser(): void {
  setEmojiParserConfig({
    emojiProvider,
    get emojiRegex() {
      return UnicodeEmojis.EMOJI_SURROGATE_RE;
    },
    skinToneSurrogates: SKIN_TONE_SURROGATES,
  });
}
